import * as React from "react";
const SvgComputerChip = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.686 1.871v3.754H1.689v1.498h2.997v4.129H1.689v1.496h2.997v4.129H1.689v1.498h2.997v3.754h14.628v-3.754h2.997v-1.498h-2.997v-4.129h2.997v-1.496h-2.997V7.123h2.997V5.625h-2.997V1.871H12ZM6.19 3.38H17.81V20.62H6.19V12ZM12 16.877v1.498h3.754v-1.498h-1.877z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgComputerChip;
